<ejs-multiselect  #multiselect
                  [id]="id"
                  [allowFiltering]="true"
                  [dataSource]="data"
                  [(value)]="outputValue"
                  [width]="width"
                  [enabled]="!isDisabled"
                  [ngClass]="{'h-auto': outputValue !== null}"
                  [fields]="fieldsSettings">
</ejs-multiselect>
